import type {
  StoryRefreshTriggerRequestApi,
  StoryRefreshTriggerResponseApi,
  StoryRefreshTriggerResult,
} from "./storyRefreshNow.types";

/**
 * Body for the POST. The spec marks the body optional and defaults `force` to
 * `false`, so the un-forced call sends `{}` rather than an explicit
 * `{ force: false }` — `apiService.post` requires a body object, and an empty
 * one is the closest legal equivalent to omitting it.
 */
export const toStoryRefreshTriggerRequest = (
  force: boolean,
): StoryRefreshTriggerRequestApi => (force ? { force: true } : {});

export const mapStoryRefreshTriggerResponse = (
  api: StoryRefreshTriggerResponseApi,
): StoryRefreshTriggerResult => ({
  refreshJobId: api.refresh_job_id,
  storyId: api.story_id,
  status: api.status,
  triggeredAt: api.triggered_at,
});
